import { z } from 'zod'

import { API_URL } from '@/modules/shared/constants/API_URL'
import { httpAuthenticationInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPAuthenticationInterceptor'
import HTTPExceptionInterceptor from '@/modules/shared/modules/http/domain/services/HTTPExceptionInterceptor'
import { httpTokenInterceptor } from '@/modules/shared/modules/http/domain/services/HTTPTokenInterceptor'
import { PersonaInfoSummary } from '@/modules/shared/schemas/PersonaInfoSummary'

export const MembershipRequestStatus = z.enum([
  'ACCEPTED',
  'REFUSED',
  'NOT_ANSWERED'
])
export type MembershipRequestStatus = z.infer<typeof MembershipRequestStatus>

export const MembershipRequestArray = z.array(
  z.object({
    requestId: z.number(),
    persona: PersonaInfoSummary,
    groupId: z.string(),
    groupName: z.string(),
    status: MembershipRequestStatus
  })
)
export type MembershipRequestArray = z.infer<typeof MembershipRequestArray>

export const MembershipRequest = z.object({
  requestId: z.number(),
  persona: PersonaInfoSummary,
  groupId: z.string(),
  groupName: z.string(),
  status: MembershipRequestStatus
})
export type MembershipRequest = z.infer<typeof MembershipRequest>

const getGroupMembershipRequests = async (
  groupId?: string
): Promise<MembershipRequestArray> => {
  const response = await HTTPExceptionInterceptor(
    await httpAuthenticationInterceptor(
      await fetch(
        `${API_URL}/v2/groups/${groupId}/membership-requests`,
        httpTokenInterceptor({
          method: 'GET'
        })
      )
    )
  )

  const data = MembershipRequestArray.parse(await response.json())
  return data
}

export default getGroupMembershipRequests
